type AddressType = Record<'Arrival' | 'Departure', 1 | 2>

/**
 * 1 发货
 * 2 收货
 */
export const ADDRESS_TYPE: AddressType = {
  Departure: 1,
  Arrival: 2,
}

type AddressRadioType = Record<'SELECT' | 'CUSTOM', 'select' | 'custom'>

export const ADDRESS_RADI_TYPE: AddressRadioType = {
  SELECT: 'select',
  CUSTOM: 'custom',
}

/** 国家地址的层级，默认是三级地址 */
export const COUNTRIES_HAVE_LEVEL_4 = {
  VN: 4,
}
